import { Component, input, effect, forwardRef } from '@angular/core';
import { IEntityProperty } from '@app/core/models/entity-property.model';
import { KENDO_DROPDOWNLIST } from '@progress/kendo-angular-dropdowns';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-select-property-code',
  template: `<kendo-dropdownlist
    [data]="properties()"
    textField="description"
    valueField="code"
    [disabled]="disabled"
    [valuePrimitive]="true"
    [value]="selectedPropertyCode"
    (valueChange)="onValueChange($event)"
  >
  </kendo-dropdownlist>`,
  styleUrls: ['./select-property.component.css'],
  imports: [KENDO_DROPDOWNLIST],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectPropertyComponent),
      multi: true,
    },
  ],
})
export class SelectPropertyComponent implements ControlValueAccessor {
  public readonly properties = input.required<IEntityProperty[]>();

  selectedPropertyCode: string = null;
  private onChanged!: Function;
  private onTouched!: Function;

  disabled: boolean = false;

  constructor() {
    effect(() => {});
  }
  onValueChange(property: any) {
    console.log('onValueChange', property);
    this.selectedPropertyCode = property ?? null;
    this.onChanged(this.selectedPropertyCode);
  }

  writeValue(value: string): void {
    this.selectedPropertyCode = value;
  }

  registerOnChange(onChange: any): void {
    this.onChanged = onChange;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
